export type ValueType = 'currency' | 'numeric' | 'percentage';

export enum ValueRoundingOptions {
  Hundredths = -2,
  Tenths = -1,
  Thousands = 3,
  Hundreds = 2,
  Tens = 1,
  Ones = 0,
  Standard = '-1',
  Accounting = '(1)'
}

export type ZeroNumbersFormatting = {
  label: string;
  enabled: boolean;
};

export type ValueFormatting = {
  currencyRounding: ValueRoundingOptions | number;
  numberRounding: ValueRoundingOptions | number;
  percentRounding: ValueRoundingOptions | number;
  negativeNumberDisplay: ValueRoundingOptions;
  zeroNumbers: ZeroNumbersFormatting[];
};
